import styled from "styled-components";


export const BlockRow = styled.div`
    display: flex;
    align-items: center;
`